import Signal from '@/webgl/core/Signal'
import AnimationSequence from '@/webgl/runner/animations/AnimationSequence'
import EyeRevealAnimation from '@/webgl/runner/animations/EyeRevealAnimation'
import LanesRevealAnimation from '@/webgl/runner/animations/LanesRevealAnimation'
import PlayerRevealAnimation from '@/webgl/runner/animations/PlayerRevealAnimation'
import RailsRevealAnimation from '@/webgl/runner/animations/RailsRevealAnimation'
import SmokeRevealAnimation from '@/webgl/runner/animations/SmokeRevealAnimation'
import GameWorld from '@/webgl/runner/GameWorld'
import { IRunnerRenderer } from '@/webgl/runner/interfaces/IRunnerRenderer'
import { ScenarioSetup } from '@/webgl/runner/scenarios/ScenarioSetup.types'
import BackgroundSystem from '@/webgl/runner/systems/BackgroundSystem'
import { IGameSegment } from '@/webgl/runner/systems/SequencingSystem'

export class Intro implements IGameSegment {
  intro: AnimationSequence
  onComplete = new Signal<void>()
  world: GameWorld

  constructor(
    readonly id: string,
    readonly scrollingItems: string[] = []
  ) {}

  init(world: GameWorld, renderer: IRunnerRenderer, setup: ScenarioSetup) {
    this.world = world
    this.intro = new AnimationSequence()

    this.intro.add(new EyeRevealAnimation(renderer.eye))

    this.intro.add(
      new LanesRevealAnimation(renderer.lanes, {
        delay: 0.4,
        laneLength: this.world.settings.LANE_LENGTH,
      })
    )

    this.intro.add(new SmokeRevealAnimation(renderer.smoke, { delay: 1.1, duration: 3.0 }))
    this.intro.add(new RailsRevealAnimation(renderer.rails, { delay: 0.9 }))
    this.intro.add(new PlayerRevealAnimation(renderer.player, { delay: 1.2 }))
  }

  start(): void {
    const settings = this.world.settings
    this.world.background.spawnableItems = this.scrollingItems
    const background: BackgroundSystem = this.world.systems.get(BackgroundSystem)
    for (let i = 0; i < 2; i++) {
      const item = background.spawnItem()
      if (item) item.node.position[2] = -settings.LANE_LENGTH * (1.0 * 0.8 - Math.random() * 0.2)
    }

    this.world.settings.scrollSpeed = 0
    this.intro.init()
    this.intro.play().then(() => this.onComplete.emit(null))
  }

  stop(): void {
    this.onComplete.release()
  }
}
